import { render, staticRenderFns } from "./Classic.vue?vue&type=template&id=2f04aec2&scoped=true"
import script from "./Classic.vue?vue&type=script&lang=js"
export * from "./Classic.vue?vue&type=script&lang=js"
import style0 from "./Classic.vue?vue&type=style&index=0&id=2f04aec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f04aec2",
  null
  
)

export default component.exports